var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_278",
    "data-name": "Raggruppa 278",
    transform: "translate(-8633 -9377)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_770",
    "data-name": "Tracciato 770",
    d: "M7954.07.038H7517.78a37.361,37.361,0,0,0-37.78,36.9V475.05A37.387,37.387,0,0,0,7517.78,512h436.29A37.471,37.471,0,0,0,7992,475.05V36.911A37.443,37.443,0,0,0,7954.07,0",
    transform: "translate(1153 9377)",
    fill: "#0a66c2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_771",
    "data-name": "Tracciato 771",
    d: "M7840.39,436.256h75.86l.03-134.026c0-65.8-14.18-116.372-91.07-116.372a79.809,79.809,0,0,0-71.85,39.465h-1.02V191.935h-72.83V436.249h75.86V315.388c0-31.871,6.05-62.738,45.56-62.738,38.95,0,39.46,36.47,39.46,64.8Z",
    transform: "translate(1153 9377)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_772",
    "data-name": "Tracciato 772",
    d: "M7549.88,114.522a44.025,44.025,0,1,0,44.02-44.033A44.023,44.023,0,0,0,7549.88,114.522Z",
    transform: "translate(1153 9377)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_773",
    "data-name": "Tracciato 773",
    d: "M7555.9,436.256h75.94V191.935H7555.9Z",
    transform: "translate(1153 9377)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.32ef96520cde9da4bb720fb5ade97e4a.svg";
export { ForwardRef as ReactComponent };